import { devices } from "@/mocks/movieData";
import SectionHeading, { Section } from "./SectionHeading";
import { useScrollReveal } from "@/hooks/useScrollReveal";

const headStyles = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-secondary-500 text-background-50",
];

export default function DeviceCompare() {
  const { ref, visible } = useScrollReveal<HTMLDivElement>();

  return (
    <Section id="devices" className="bg-background-50">
      <SectionHeading
        eyebrow="多端对比"
        accent="secondary"
        title="网页端、手机浏览器、APP 到底怎么选"
        description="三种方式能看到的内容基本一致，差别在于是否需要安装、能不能离线缓存，以及适合的使用场景。对照下面几项就能快速做出选择。"
      />

      <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 section-reveal ${visible ? "is-visible" : ""}`}>
        {devices.map((device, index) => (
          <article
            key={device.id}
            className="flex flex-col rounded-lg border border-background-200 overflow-hidden bg-background-50"
          >
            <div className={`px-4 md:px-5 py-4 ${headStyles[index % headStyles.length]}`}>
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-white/20">
                  <i className={`${device.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="text-xs font-label px-2 py-1 rounded-full bg-white/20 whitespace-nowrap">
                  {device.tag}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl font-bold">{device.name}</h3>
              <p className="mt-1 text-xs md:text-sm opacity-90">{device.best}</p>
            </div>

            <dl className="flex-1 divide-y divide-background-200">
              {device.rows.map((row) => (
                <div key={row.label} className="flex items-center justify-between gap-3 px-4 md:px-5 py-3">
                  <dt className="text-sm text-foreground-500 font-label whitespace-nowrap">{row.label}</dt>
                  <dd className="text-sm text-foreground-900 text-right">{row.value}</dd>
                </div>
              ))}
            </dl>
          </article>
        ))}
      </div>

      <div className="mt-6 rounded-lg bg-secondary-50 border border-secondary-200 p-4 md:p-5 flex items-start gap-3">
        <i className="ri-lightbulb-line text-xl text-secondary-700 mt-0.5" aria-hidden="true"></i>
        <p className="text-sm text-foreground-700 leading-relaxed">
          小建议：不确定要不要安装客户端时，先在网页端确认内容和体验，确认自己会经常使用、并且确实需要离线缓存和后台播放，再考虑安装 APP，可以少走一步。
        </p>
      </div>
    </Section>
  );
}